module.exports = __webpack_public_path__ + "static/024-ad6dff03a9ff17be5939d313569ba6f7.jpg";